const movementSensorsIotFeature = {
    id: "iot-movement-sensor",
    name: "feature.iot-movement-sensor.name",
    iconClass: "fal fa-sensor-on",
    globalSettings: {},
    schema: {}
};

export { movementSensorsIotFeature };